module.exports = __webpack_public_path__ + "img/Mstorybg301.c0fa6df0.png";